import React from 'react';

import { IComponent } from '../../../typings/generic-component';
import { DRIVERFLAG, placeholdersMap } from '../../../utils/placeholders-motorsports';
import { makeClassNames } from '../../../utils/styles';
import ImgPlaceholder from '../../atoms/img-placeholder/img-placeholder';
import Text from '../../atoms/text/text';
import './top-three.scss';

export type TopThreeItem = {
  customDriverName: string;
  flagImgUrl: string;
  position: number;
};

export interface ITopThree extends IComponent {
  topThree: TopThreeItem[];
}

const classNames = () =>
  makeClassNames({
    topThreeListContainer: 'top-three__list-container',
    topThreeImg: 'top-three__img',
  });

const TopThree = ({ topThree }: ITopThree) => {
  const cn = classNames();

  return (
    <ol className={cn.topThreeListContainer}>
      {topThree.map((t) => (
        <li key={t.position}>
          <Text color="light" fontWeight="500" fontSize="16">
            {t.position}.
          </Text>
          <ImgPlaceholder
            placeholder={placeholdersMap[DRIVERFLAG]}
            src={t.flagImgUrl}
            alt=""
            className={cn.topThreeImg}
          />
          <Text color="light" fontWeight="500" fontSize="16">
            {t.customDriverName}
          </Text>
        </li>
      ))}
    </ol>
  );
};

export default TopThree;
